import React, { act } from "react";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions";
import PrimaryButton from "../buttons/PrimaryButton";
import { updateDocDataField } from "../models/DataFunctions";

import { SketchPicker } from "react-color";
import { flutterColorToHex, HexColorToFlutter } from "../config/theme";
import Modal1 from "./Modal1";
import { useAppContext } from "../config/AppContext";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";

const MemberColorModal = ({ onClose, user_id, onUpdate }) => {
  const [actualuserData, setActualUserData] = useState(null);
  const [actualorgData, setActualOrgData] = useState(null);
  const { currentUser, loading } = useAuth();

  const [color, setColor] = useState("#fff");

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleSaveMemberColor = async () => {
    const fluttercolor = HexColorToFlutter(color.hex);
    await updateDocDataFieldApi(
      actualuserData.ref,
      "color",
      fluttercolor,
      prefix
    );
    handleClickVariant("Couleur mise à jour avec succès", "success");
    onUpdate();
    onClose();
  };

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const actualuser = await getUserById(user_id);
        const actualorg = await getOrgById(actualuser.org_id);

        const color = flutterColorToHex(actualuser.color);
        setColor(color);

        setActualUserData(actualuser);
        setActualOrgData(actualorg);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  if (loading || !currentUser || !actualorgData) {
    return <> Loading ..</>;
  }

  return (
    <div className="bg-white flex flex-col p-4 w-fit rounded-3xl gap-3 ">
      <SketchPicker color={color} onChange={(color) => setColor(color)} />
      <PrimaryButton onClick={handleSaveMemberColor}>Enregistrer</PrimaryButton>
    </div>
  );
};

export default MemberColorModal;
